import { CSSTransition } from 'react-transition-group';
import { useLayoutSelector } from '../../redux';
import { StyledModalWrapper } from '../ModalChangeName/ModalChangeName.styled';
import { ModalChangeNameFormPanel } from '../ModalChangeName/ModalChangeName';
import { ModalChangeNamePendingPanel } from '../ModalChangeNamePending/ModalChangeNamePending';
import { ModalChangeNameRejectedPanel } from '../ModalChangeNameRejected/ModalChangeNameRejected';

const ModalChangeNameOverlay = () => {
	const form = useLayoutSelector((state) => state.modal.modalChangeNameVisible);
	const pending = useLayoutSelector(
		(state) => state.modal.modalChangeNamePendingVisible,
	);
	const rejected = useLayoutSelector(
		(state) => state.modal.modalChangeNameRejectedVisible,
	);
	const open = form || pending || rejected;

	const panel = form ? (
		<ModalChangeNameFormPanel key="form" />
	) : pending ? (
		<ModalChangeNamePendingPanel key="pending" />
	) : rejected ? (
		<ModalChangeNameRejectedPanel key="rejected" />
	) : null;

	return (
		<CSSTransition in={open} timeout={500} classNames="modal" unmountOnExit>
			<StyledModalWrapper>{panel}</StyledModalWrapper>
		</CSSTransition>
	);
};

export { ModalChangeNameOverlay };
